export default "__VITE_ASSET___KXgc5Dq__"